<div class="map-container" [class.loading]="!isReady">
  <input *ngIf="withSearch" [ngModel]="searchText" class="map-search-input" #autocomplete type="text" size="50" placeholder="Select Address" />
  <div #map [ngClass]="mapContainerCss"></div>

  <app-page-spinner *ngIf="!isReady" mode="indeterminate" color="primary" [strokeWidth]="2" [diameter]="20" [style.margin-left.px]="10"></app-page-spinner>
</div>
